import { Button, Combobox, Flex } from '@mantine/core';
import { observer } from 'mobx-react-lite';
import * as React from 'react';

import FieldSelect from 'components/shared/form/FieldSelect';
import { useCreateMeetingDrawerModal } from 'stores/global/CreateMeetingDrawerModal';
import { FixationMode } from 'stores/global/RootStore/AppConfigStore';
import { useAppConfig } from 'stores/global/RootStore/context';
import { CreateMeetingDrawerModalMode } from 'types/CreateMeetingDrawerModalMode';

import Detail from '../Detail';
import SubAgentSelect from '../SubAgentSelect';

const CreateWithNewLead: React.FC = () => {
  const { logic } = useAppConfig();
  const createMeetingDrawerModal = useCreateMeetingDrawerModal();
  const {
    client,
    leadSelectStore,
    hasLeadOptions,
    createLoadingStage,
    isStaticMode,
    projectTimeSlot,
    clientUniquenessStore,
  } = createMeetingDrawerModal;

  const onCreateClient = React.useCallback(() => {
    createMeetingDrawerModal.createClientStore.reset();
    isStaticMode.change(CreateMeetingDrawerModalMode.openCreateClient);
  }, [isStaticMode, createMeetingDrawerModal]);

  const createClientOptionsFooter = React.useCallback(
    (beforeCreateClient: () => void) => (
      <Combobox.Footer>
        <Button
          size="md"
          // eslint-disable-next-line
          onClick={() => {
            beforeCreateClient();
            onCreateClient();
          }}
          disabled={
            clientUniquenessStore.shouldCheckUniqueByPhoneAndProject && projectTimeSlot.projects.value.length === 0
          }
          fullWidth
        >
          Создать клиента
        </Button>
      </Combobox.Footer>
    ),
    [onCreateClient, clientUniquenessStore.shouldCheckUniqueByPhoneAndProject, projectTimeSlot.projects.value],
  );

  return (
    <Flex direction="column" gap="xl" w="100%">
      {clientUniquenessStore.shouldCheckUniqueByPhoneAndProject && (
        <FieldSelect
          fw="600"
          label="Проект"
          placeholder="Выберите проект"
          store={projectTimeSlot.projects}
          disabled={createLoadingStage.isLoading}
        />
      )}
      {(!clientUniquenessStore.shouldCheckUniqueByPhoneAndProject || projectTimeSlot.projects.value.length > 0) && (
        <FieldSelect
          fw="600"
          label="Клиент"
          placeholder="Выберите клиента"
          store={client}
          disabled={createLoadingStage.isLoading}
          optionsFooter={logic.fixation.mode === FixationMode.SingleWindow ? undefined : createClientOptionsFooter}
        />
      )}
      {client.value.length !== 0 && <SubAgentSelect />}
      {client.value.length !== 0 && leadSelectStore.shown && (
        <FieldSelect
          fw="600"
          label="Заявка"
          placeholder={hasLeadOptions ? 'Выберите заявку' : 'Заявок нет'}
          store={leadSelectStore}
          disabled={createLoadingStage.isLoading || !hasLeadOptions}
        />
      )}
      {client.value.length !== 0 &&
        (!leadSelectStore.shown || leadSelectStore.value.length > 0) &&
        !clientUniquenessStore.shouldHideDetails && <Detail />}
    </Flex>
  );
};

export default observer(CreateWithNewLead);
